import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './Icon.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

class Icon extends React.Component {

  static defaultProps = {
    size: 41,
  };

  render() {
    const size = {
      width: this.props.fullSize ? '100%' : this.props.size,
      height: this.props.fullSize ? '100%' : this.props.size,
    };
    const { iconName, small } = this.props;
    const className = small 
      ? cx(s.Icon, s.block, s.small, s[iconName])
      : cx(s.Icon, s.block, s[iconName]);
    return (
      <div 
        className={className} 
        style={size} 
        onClick={this.props.onClick}>
        {this.props.children}
      </div>
    );
  }
}


Icon.propTypes = {
  iconName: PropTypes.string,
  size: PropTypes.number,
  fullSize: PropTypes.bool,
  small: PropTypes.bool,
};

Icon.defaultProps = {
  small: false,
};

export default withStyles(s)(Icon);



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js